module.exports = __webpack_public_path__ + "static/media/logout-header.7168a623.svg";